import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { AmorgAdminToken } from '../../../amorg-common';
import { getActiveUser } from '../../../api/adminClientApi';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Tabber, TabItem } from '../../../designSystem/Tabber';

export type AdminTabProps =
{
    selectedTab: 'overview' | 'sites' | 'organizations' | 'users' | 'globaltemplates' | 'articles' | 'profile';
};

export function AdminTab (props: AdminTabProps): JSX.Element
{
    const [userToken, setUserToken] = React.useState<AmorgAdminToken | null>(null);

    const navigate = useNavigate();

    React.useEffect(() => {
        (async () => {
            setUserToken(await getActiveUser(() => navigate('/amorgy/login')));
        })();
    }, [])

    function handleTabChange (tab: typeof props.selectedTab)
    {
        if (tab === 'overview')
            navigate('/amorgy/overview');
        else if (tab === 'sites')
            navigate('/amorgy/sites');
        else if (tab === 'organizations')
            navigate('/amorgy/organizations');
        else if (tab === 'users')
            navigate('/amorgy/users');
        else if (tab === 'globaltemplates')
            navigate('/amorgy/globaltemplates');
        else if (tab === 'articles')
            navigate('/amorgy/articles');
        else if (tab === 'profile')
            navigate('/amorgy/profile');
        else
            alert('unsupported tab selected: ' + tab);
    }

    const items:TabItem[] = [
        {
            tabName: 'overview',
            text: 'Overblik'
        },
        {
            tabName: 'sites',
            text: 'Sites'
        },
        {
            tabName: 'organizations',
            text: 'Organisationer'
        },
        {
            tabName: 'users',
            text: 'Brugere'
        }
    ];
    
    if(userToken?.partner === null)
        items.push({ tabName: 'globaltemplates', text: 'Survey Skabeloner' });
    
    if(userToken?.partner === null || userToken?.partner === 'Crecea')
        items.push({ tabName: 'articles', text: 'Lovservice' });

    items.push({ tabName: 'profile', text: 'Profil' });

    return (
        
        <Flex gap={16} alignItems='center'>

            <Tabber
                style={{flexGrow: 1}}
                variant='default'
                onClick={(tabName) => handleTabChange(tabName as typeof props.selectedTab)}
                selectedTabName={props.selectedTab}
                items={items}
            />
            <LinkButton variant='outlined' text='log ud' icon="logout" href='/amorgy/logout' size="42px" />
        </Flex>
        
    );
}